// mutation_types
// export const SET_IS_SEARCH_INIT = 'SNAPSHOT/SET_IS_SEARCH_INIT';
export const SET_LISTING_STATUS = 'SNAPSHOT/SET_LISTING_STATUS';
export const SET_LISTING = 'SNAPSHOT/SET_LISTING';
export const SET_MARKET_REPORT = 'SNAPSHOT/SET_MARKET_REPORT';
export const SET_CURRENT_LISTING_STATUS = 'SNAPSHOT/SET_CURRENT_LISTING_STATUS';
export const SET_CURRENT_LISTING_NAME = 'SNAPSHOT/SET_CURRENT_LISTING_NAME';
export const SET_FETCH_MARKET_REPORT_STATUS =
    'SNAPSHOT/SET_FETCH_MARKET_REPORT_STATUS';
export const SET_FETCH_LISTING_STATUS = 'SNAPSHOT/SET_FETCH_LISTING_STATUS';
export const SET_TOTAL_PAGE = 'SNAPSHOT/SET_TOTAL_PAGE';
export const SET_PAGE_NUM = 'SNAPSHOT/SET_PAGE_NUM';
export const SET_MORE_BTN_TITLE = 'SNAPSHOT/SET_MORE_BTN_TITLE';
export const SET_MORE_BTN_STYLE = 'SNAPSHOT/SET_MORE_BTN_STYLE';
export const SET_LISTING_TITLE = 'SNAPSHOT/SET_LISTING_TITLE';
export const SET_SHOW_SOLD_LISTING_PRICE =
    'SNAPSHOT/SET_SHOW_SOLD_LISTING_PRICE';
export const SET_SHOW_LISTING_PRICE = 'SNAPSHOT/SET_SHOW_LISTING_PRICE';
export const UPDATE_SEARCH_PARAMS = 'SNAPSHOT/UPDATE_SEARCH_PARAMS';
// action_types
export const GET_LISTING_STATUS = 'SNAPSHOT/GET_LISTING_STATUS';
export const GET_LISTING = 'SNAPSHOT/GET_LISTING';
export const GET_MARKET_REPORT = 'SNAPSHOT/GET_MARKET_REPORT';
export const ADD_SOLD_PICTURE = 'SNAPSHOT/ADD_SOLD_PICTURE';
